import React from "react";
import { SiAboutdotme } from "react-icons/si";
import { FiCode, FiServer, FiCpu, FiSmartphone } from "react-icons/fi";
import Heading from "../../reusable/Heading";
import Detail from "./Detail.jsx";
import SkillCard from "./SkillCard";
import { myEducations, myExperiences, skillCategories } from "../../../data/resume";
import css from "./resume.module.css";
import useScrollReveal from "../../../hooks/useScrollReveal";

const categoryIcons = [
  <FiCode />,
  <FiServer />,
  <FiCpu />,
  <FiSmartphone />,
];

const Resume = () => {
  const headingRef = useScrollReveal();
  const eduRef = useScrollReveal();
  const expRef = useScrollReveal();
  const skillsRef = useScrollReveal();

  return (
    <div
      style={{ paddingBottom: "7%" }}
      className="container px-lg-5"
    >
      <div ref={headingRef} className="reveal">
        <Heading icon={<SiAboutdotme />} headingTitle="Experience & Capabilities" />
      </div>

      <p className={css.intro}>
        Hands-on delivery across client work and product builds from responsive
        interfaces and backend systems to cross-platform apps and AI-enabled
        features.
      </p>

      <div className="row gx-5">
        <div className="col-md-6">
          <div ref={eduRef} className="reveal reveal-delay-1">
            <h2 className={css.sectionTitle}>Training</h2>
            {myEducations.map((item, i) => (
              <Detail
                key={i}
                firstDate={item.firstDate}
                secondDate={item.secondDate}
                diplomaORexperience={item.diplomaORexperience}
                location={item.location}
                decription={item.decription}
              />
            ))}
          </div>
        </div>

        <div className="col-md-6">
          <div ref={expRef} className="reveal reveal-delay-2">
            <h2 className={css.sectionTitle}>Delivery Experience</h2>
            {myExperiences.map((item, i) => (
              <Detail
                key={i}
                firstDate={item.firstDate}
                secondDate={item.secondDate}
                diplomaORexperience={item.diplomaORexperience}
                location={item.location}
                decription={item.decription}
              />
            ))}
          </div>
        </div>
      </div>

      <div ref={skillsRef} className={`${css.skillsSection} reveal reveal-delay-3`}>
        <h2 className={css.sectionTitle}>Technical Range</h2>
        <p className={css.skillsIntro}>
          The tools I use to move confidently across web, backend, AI, mobile, and deployment work.
        </p>
        <div className="row g-4">
          {skillCategories.map((cat, i) => (
            <div key={i} className="col-md-6 col-xl-3">
              <SkillCard category={cat.category} skills={cat.skills} icon={categoryIcons[i]} index={i} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Resume;
